const RESULTS_TABS = new Set(['championship', 'cup', 'supercup']);

/**
 * Canonical public URL for a Results competition tab (/results?tab=).
 * Returns null when the competition type is unknown.
 */
export function resultsTabPath(competitionType) {
    if (!RESULTS_TABS.has(competitionType)) {
        return null;
    }

    return `/results?tab=${competitionType}`;
}

/**
 * Normalize a ?tab= query value to a known Results tab key.
 */
export function parseResultsTab(value, fallback = 'championship') {
    if (RESULTS_TABS.has(value)) {
        return value;
    }

    return fallback;
}
